function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Grid } from '@signicat/designi/components/layout';
import { Icon } from '@signicat/designi/components/icons';
import { Label } from '@signicat/designi/components/forms';
import { Segment } from '@signicat/designi/components/containers';
import { Div } from '@signicat/designi/components/layout';
import { HelpText } from '@signicat/designi/components/text';
import { Select } from '@signicat/designi/components/inputs';
import { t } from "../../../helpers/i18n";
var SignatureMethod = function SignatureMethod(props) {
  var mechanism = props.mechanism,
    defaultMethods = props.defaultMethods,
    disabled = props.disabled;
  var currentStack = useSelector(function (state) {
    return state.module.settings.stack;
  });
  var stackData = useSelector(function (state) {
    return state.module.stacks[currentStack];
  });
  var signMechanismsAndIdps = mechanism === 'choose_every_time' ? stackData.signMechanisms : _defineProperty({}, mechanism, stackData.signMechanisms[mechanism]);
  var _useState = useState(defaultMethods !== null && defaultMethods !== void 0 ? defaultMethods : []),
    _useState2 = _slicedToArray(_useState, 2),
    selectedSignMethods = _useState2[0],
    setSelectedSignMethods = _useState2[1];
  useEffect(function () {
    var updateMethods = _toConsumableArray(defaultMethods);
    if (updateMethods) {
      if (mechanism && mechanism !== 'choose_every_time') {
        updateMethods = defaultMethods.filter(function (m) {
          return m.includes(mechanism);
        });
      }
      // Filter out invalid methods (if removed as allowed methods etc.)
      updateMethods = updateMethods.filter(function (dm) {
        var _signMechanismsAndIdp;
        var mech = dm.split('.')[0];
        var idp = dm.split('.')[1];
        var allowdIdpsForMech = (_signMechanismsAndIdp = signMechanismsAndIdps[mech]) === null || _signMechanismsAndIdp === void 0 ? void 0 : _signMechanismsAndIdp.map(function (m) {
          return m.idp;
        });
        return allowdIdpsForMech === null || allowdIdpsForMech === void 0 ? void 0 : allowdIdpsForMech.includes(idp);
      });
      setSelectedSignMethods(updateMethods);
    }
  }, [defaultMethods]);
  var signMethodAllowed = function signMethodAllowed(mechanism) {
    return !selectedSignMethods || selectedSignMethods.every(function (val) {
      return val.includes(mechanism);
    });
  };
  var signMethodsOptions = (Object.keys(signMechanismsAndIdps) || []).filter(function (signMechanism) {
    return signMechanismsAndIdps[signMechanism] && signMechanismsAndIdps[signMechanism].length > 0;
  }).map(function (signMechanism) {
    var disabled = stackData.allowMultipleSignMechanisms ? false : !signMethodAllowed(signMechanism);
    return {
      text: "".concat(t("sign_mechanism_".concat(signMechanism))).concat(disabled ? " (".concat(t('sign_mechanisms_hint_cannot_be_combined_with_other'), ")") : ''),
      value: signMechanism,
      disabled: disabled,
      options: signMechanismsAndIdps[signMechanism].map(function (idp) {
        return {
          value: idp.idp,
          text: t("idp_".concat(idp.idp)),
          disabled: false
        };
      })
    };
  });
  var onSignMethodsChange = function onSignMethodsChange(e) {
    var signMethods = e.target.value;
    setSelectedSignMethods(signMethods);
    props.onSignMethodsChange(signMethods);
  };
  return /*#__PURE__*/React.createElement(Div, null, /*#__PURE__*/React.createElement(Segment, {
    divided: true,
    outlined: true,
    direction: "column",
    marginBottom: "32px"
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    direction: "row"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    direction: "row",
    alignItems: "stretch"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    style: {
      flex: '0 0 auto',
      alignItems: 'flex-start'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "edit",
    style: {
      paddingLeft: '4px',
      paddingTop: '12px'
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    style: {
      flex: '1 0 0'
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "column",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Label, null, t('form_label_sign_methods')), /*#__PURE__*/React.createElement(HelpText, {
    style: {
      marginTop: '2px'
    }
  }, t('module_settings_signmethods_input_helptext')))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(Select, {
    id: "signature_sign_methods",
    label: t('form_label_sign_methods'),
    options: signMethodsOptions,
    onChange: onSignMethodsChange,
    value: selectedSignMethods,
    renderValue: function renderValue(selected) {
      return selected.map(function (val) {
        return t("idp_".concat(val.split('.')[1]));
      }).join(', ');
    },
    multiple: true,
    fullWidth: true,
    disabled: disabled
  })))));
};
export default SignatureMethod;